import React from "react";
import "../../App.css";
import NavbarComp from "../navbar/navbar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGithub,
  faLinkedin,
  faXTwitter,
  faGoogleScholar,
} from "@fortawesome/free-brands-svg-icons";
import {
  faEnvelope,
  // faGraduationCap,
  // faMapPin,
  // faUserTie,
} from "@fortawesome/free-solid-svg-icons";

class Home extends React.Component {
  render() {
    const accentLinkStyle = { color: "#168f7c", textDecoration: "none" };

    return (
      <div className="container d-flex justify-content-center mt-5">
        <div className="centered-box w-lg-75 w-100">
          <NavbarComp />

          <div className="home-page">
            <div className="row align-items-center home-hero">
              <div className="col-lg-4 col-12">
                <img
                  src="/images/subhed-photos/subhed6-compressed.jpg"
                  alt="Subhed Chavan headshot"
                  loading="lazy"
                  className="home-profile-photo"
                />
              </div>

              <div className="col-lg-8 mt-lg-0 mt-4 col-12">
                <div className="home-hero-copy">
                  <div className="home-kicker">
                    <span>Senior Software Engineer</span>
                    <span>Backend · Cloud · Real-Time Systems</span>
                  </div>

                  <p className="home-intro">
                    I build backend systems, cloud infrastructure, and DevOps
                    tooling for production platforms where reliability,
                    scalability, and developer velocity matter.
                  </p>

                  <div className="home-proof-row">
                    <div className="home-proof-item">
                      <div className="home-proof-icon">
                        {/* <FontAwesomeIcon icon={faUserTie} /> */}
                      </div>

                      <div className="home-proof-content">
                        <strong>5+ Years</strong>
                        <span>Professional Experience</span>
                      </div>
                      <svg
                        className="home-proof-watermark"
                        viewBox="0 0 120 120"
                        aria-hidden="true"
                      >
                        <path d="M60 13 100 35v47L60 106 20 82V35Z" />
                        <path d="m20 35 40 23 40-23M60 58v48" />
                        <path d="m38 25 40 23M38 92l40-23" opacity=".55" />
                      </svg>
                    </div>

                    <div className="home-proof-item">
                      <div className="home-proof-icon">
                        {/* <FontAwesomeIcon icon={faGraduationCap} /> */}
                      </div>

                      <div className="home-proof-content">
                        <strong>MS in Computer Science</strong>
                        <span>California State University, Chico</span>
                      </div>
                      <svg
                        className="home-proof-watermark"
                        viewBox="0 0 120 120"
                        aria-hidden="true"
                      >
                        <path d="m16 46 44-25 44 25-44 25Z" />
                        <path d="M35 57v20c14 13 36 13 50 0V57" />
                        <path d="M92 50v24" />
                        <circle cx="92" cy="77" r="3" />
                        <path d="m36 76 24 14 24-14" opacity=".55" />
                      </svg>
                    </div>

                    <div className="home-proof-item">
                      <div className="home-proof-icon">
                        {/* <FontAwesomeIcon icon={faMapPin} /> */}
                      </div>

                      <div className="home-proof-content">
                        <strong>Chico, CA</strong>
                        <span>United States</span>
                      </div>
                      <svg
                        className="home-proof-watermark"
                        viewBox="0 0 120 120"
                        aria-hidden="true"
                      >
                        <path d="M60 102S29 72 29 49a31 31 0 1 1 62 0c0 23-31 53-31 53Z" />
                        <circle cx="60" cy="49" r="10" />
                        <path d="m18 91 42-24 42 24M30 98l30-17 30 17" opacity=".55" />
                      </svg>
                    </div>
                  </div>

                  <div className="home-capabilities" aria-label="Core skills">
                    <span>Distributed Systems</span>
                    <span>Node.js</span>
                    <span>Python / FastAPI / Flask</span>
                    <span>Java / Spring Boot</span>
                    <span>AWS</span>
                    <span>Terraform</span>
                    <span>CI/CD</span>
                    <span>Observability</span>
                    <span>Unreal Engine Backends</span>
                  </div>

                  <div className="home-actions">
                    <a
                      className="home-primary-link"
                      href="mailto:chavansubhed@gmail.com"
                    >
                      Contact me
                    </a>
                    <a
                      className="home-secondary-link"
                      href="/resume/Subhed_Chavan.pdf"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Resume
                    </a>
                  </div>

                  <div className="home-socials" aria-label="Profile links">
                    <a
                      href="https://github.com/subhed"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FontAwesomeIcon icon={faGithub} /> GitHub
                    </a>

                    <a
                      href="https://linkedin.com/in/subhed"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FontAwesomeIcon icon={faLinkedin} /> LinkedIn
                    </a>

                    <a
                      href="https://twitter.com/subhed"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FontAwesomeIcon icon={faXTwitter} /> Twitter
                    </a>

                    <a
                      href="https://scholar.google.com/citations?user=PPi-uIUAAAAJ&hl=en"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FontAwesomeIcon icon={faGoogleScholar} /> Scholar
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-4" id="about">
              <h5>About</h5>
              <hr />

              <p>
                <strong>Senior Software Engineer</strong> with deep expertise in{" "}
                <strong>Backend Systems</strong>,{" "}
                <strong>Distributed Systems</strong>,{" "}
                <strong>Real-Time Platforms</strong>, and{" "}
                <strong>DevOps</strong>. I currently work remotely from{" "}
                <strong>Chico, CA</strong> with the{" "}
                <strong>Interior Logic Group Inc.</strong> (A Blackstone
                Company) team in <strong>San Diego, CA</strong>, building a
                next-generation platform for builders, curators, and home
                buyers-featuring real-time rendering, a dynamic pricing engine,
                and seamless integration across Web, Cloud, and Unreal Engine.
              </p>

              <p>
                Previously, at{" "}
                <strong>Curativly (Applied Internet Technology Inc.)</strong>, I
                led platform architecture and infrastructure for an AI-driven,
                AR/VR-powered renovation tech startup. I owned backend
                reliability and interactive visualization services that
                delivered curated, install-ready home designs.
              </p>

              <p>
                With over <strong>5 years of experience</strong>, I specialize
                in designing scalable backend architectures, building internal
                tools, and managing geo-distributed cloud deployments. I'm
                passionate about rapid prototyping, cross-functional
                collaboration, and delivering production-ready software that
                supports immersive, high-performance applications.
              </p>

              <p>
                <strong>Areas of Expertise:</strong> Distributed Systems ·
                Real-Time Systems · Node.js · Python (Flask, Django) · Java
                (Spring Boot) · AWS · Terraform · CI/CD · Observability ·
                Backend systems integrating Unreal Engine · 3D Visualization ·
                Geo-Distributed Cloud
              </p>

              <p>Get in touch with me for conversation or any information.</p>

              <p>
                <FontAwesomeIcon icon={faEnvelope} size="lg" /> &nbsp;{" "}
                <a
                  href="mailto:chavansubhed@gmail.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={accentLinkStyle}
                >
                  chavansubhed@gmail.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Home;
